const ROUTES = {
  dashboard: '/',
  login: '/login',
  resetPassword: '/reset-password',
  signup: '/signup',
  profile: '/profile',
  careteCard: '/services/products/:id/card',
  newPassword: '/new-password',
  viewMiles: '/miles/view',
  claimMiles: '/miles/claim',
  newMilage: '/miles/new',
  buyMilage: '/services/buy-milage',
  convertMilage: '/services/convert-milage',
  transferMilage: '/services/transfer-milage',
  freeTicket: '/services/award-ticket',
  discount: '/services/discount',
  showHistory: '/services/award-ticket/history',
  showHistoryDiscount: '/services/discount/history',
  freeTicketBook: '/services/award-ticket/book',
  discountBook: '/services/discount/book',
  freeTicketReesult: '/services/award-ticket/:id',
  products: '/services/products',
  booking: '/services/products/booking',
  calculation: '/miles/calculation', 
  verifyEmail: '/verify-email',
  tickets: '/tickets',
  createTicket: '/create_ticket',
  singleTicket: '/tickets/:ticketId',
  awardTicket: '/award_tickets',
  services: '/services',
  supervision: '/myKides',
};

export default ROUTES;
